import { useEffect, useState } from 'react'
import { Translate } from 'react-redux-i18n'
import useGetForeignRegions from '../../../../common/category/useGetForeignRegions'
import useGetVietnameseProvinces from '../../../../common/category/useGetVietnameseProvinces'
import { Element } from '../../../../common/html/element'
import { Tabs } from '../../../../common/tabs'
import classes from '../../../index.module.scss'
import { getAppendStyleItem, getTabsLocation } from '../constants'
import SelectedItem from './SelectedItem'

const LEVEL_COUNTRY = 3
const LEVEL_CITY = 4

export const InterestedLocations = () => {
  const { foreignRegions } = useGetForeignRegions()
  const { vietnameseProvinces } = useGetVietnameseProvinces()

  const [countries, setCountries] = useState([])
  const [cities, setCities] = useState([])

  useEffect(() => {
    if (foreignRegions.length) {
      setCountries(
        foreignRegions
          .filter((item) => item.level === LEVEL_COUNTRY)
          .sort((item1, item2) => item1.name.localeCompare(item2.name)),
      )
    }
  }, [foreignRegions])

  useEffect(() => {
    if (vietnameseProvinces.length) {
      setCities(
        vietnameseProvinces
          .filter((item) => item.level === LEVEL_CITY)
          .sort((item1, item2) => item1.name.localeCompare(item2.name)),
      )
    }
  }, [vietnameseProvinces])

  const tabs = getTabsLocation(cities, countries)

  return (
    <div className={classes.settingsContent} style={{ height: 250 }}>
      <Element
        className={classes.preferencesHeader}
        style={{ backgroundColor: '#F3F3F3' }}
      >
        <Element
          className="fw600"
          style={{ fontSize: 14, padding: '8px 0 8px 10px' }}
        >
          <Translate value="settingPreferences.INTERESTED_LOCATION" />
        </Element>
      </Element>
      <div className={[classes.interestedContainer, 'flexColumn'].join(' ')}>
        <div className={[classes.content, 'flex1'].join(' ')}>
          <div className="w50 h100">
            <Tabs
              items={tabs}
              tabListClassName={classes.tabs}
              getAppendStyleItem={getAppendStyleItem}
              isScrollContent={false}
              isI18n={true}
            />
          </div>
          <div className="w50 h100">
            <SelectedItem countries={countries} cities={cities} />
          </div>
        </div>
      </div>
    </div>
  )
}
